// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChatsUpdateRestPage {
  background: #EFF0F4;
  width: 100%;
  height: 100vh;
}
.ChatsUpdateRestPage .PageContent {
  display: flex;
  flex-direction: column;
  gap: 32px;
  margin-top: 56px;
}
.ChatsUpdateRestPage .PageContent .emptyList {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
}
.ChatsUpdateRestPage .PageContent .LoaderContainer {
  min-height: 487px;
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.ChatsUpdateRestPage .PageContent .CardsContent {
  padding-left: 20px;
  padding-top: 20px;
  background: white;
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 36px;
}
.ChatsUpdateRestPage .PageContent .FirstControlPanel {
  display: flex;
  gap: 40px;
}
.ChatsUpdateRestPage .PageContent .SecondControlPanelWrapper {
  display: flex;
  gap: 48px;
}
.ChatsUpdateRestPage .PageContent .SecondControlPanelWrapper .SecondControlPanelContent {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: 0.1s;
}
.ChatsUpdateRestPage .PageContent .SecondControlPanelWrapper .SecondControlPanelContent:hover {
  color: rgb(173, 164, 164);
}
.ChatsUpdateRestPage .PageContent .SecondControlPanelWrapper .SecondControlPanelContent:hover svg path {
  transition: 0.1s;
  fill: rgb(173, 164, 164);
}`, "",{"version":3,"sources":["webpack://./src/routes/pages/EstablishmentsUpdatePage/Tabs/ChatsControlPage/ChatsControlPage.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,WAAA;EACA,aAAA;AACF;AACE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AACJ;AACI;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;AACN;AAEI;EACE,iBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;AAAN;AAGI;EACE,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,SAAA;AADN;AAII;EACE,aAAA;EACA,SAAA;AAFN;AAKI;EACE,aAAA;EACA,SAAA;AAHN;AAIM;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;AAFR;AAGQ;EACE,yBAAA;AADV;AAGY;EACE,gBAAA;EACA,wBAAA;AADd","sourcesContent":[".ChatsUpdateRestPage {\n  background: #EFF0F4;\n  width: 100%;\n  height: 100vh;\n\n  .PageContent {\n    display: flex;\n    flex-direction: column;\n    gap: 32px;\n    margin-top: 56px;\n\n    .emptyList {\n      display: flex;\n      align-items: center;\n      flex-direction: column;\n      justify-content: center;\n      gap: 20px;\n    }\n\n    .LoaderContainer {\n      min-height: 487px;\n      height: 100%;\n      display: flex;\n      justify-content: center;\n      flex-direction: column;\n      align-items: center;\n    }\n\n    .CardsContent {\n      padding-left: 20px;\n      padding-top: 20px;\n      background: white;\n      display: flex;\n      justify-content: center;\n      flex-direction: column;\n      gap: 36px;\n    }\n\n    .FirstControlPanel {\n      display: flex;\n      gap: 40px;\n    }\n\n    .SecondControlPanelWrapper {\n      display: flex;\n      gap: 48px;\n      .SecondControlPanelContent {\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        transition: 0.1s;\n        &:hover {\n          color: rgb(173, 164, 164);\n          svg {\n            path {\n              transition: 0.1s;\n              fill: rgb(173, 164, 164);\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ChatsUpdateRestPage": `ChatsUpdateRestPage`,
	"PageContent": `PageContent`,
	"emptyList": `emptyList`,
	"LoaderContainer": `LoaderContainer`,
	"CardsContent": `CardsContent`,
	"FirstControlPanel": `FirstControlPanel`,
	"SecondControlPanelWrapper": `SecondControlPanelWrapper`,
	"SecondControlPanelContent": `SecondControlPanelContent`
};
export default ___CSS_LOADER_EXPORT___;
